// TOP 質問リスト
const listItems = document.querySelectorAll('.top-question__item');

listItems.forEach((item) => {
  item.addEventListener('click', () => {
    const foot = item.querySelector('.top-question__foot');
    const dliPlus = item.querySelector('.down');
    const dliMinus = item.querySelector('.up');

    if (foot.classList.contains('show')) {
      foot.classList.remove('show');
      dliPlus.style.display = 'inline-block';
      dliMinus.style.display = 'none';
    } else {
      foot.classList.add('show');
      dliPlus.style.display = 'none';
      dliMinus.style.display = 'inline-block';
    }
  });
});

// TOP 商品紹介タブ
const tabsElems = document.querySelectorAll("[data-tabs]");

if (tabsElems.length > 0) {
  tabsElems.forEach((tab) => {
    const tabBtnElems = tab.querySelectorAll("[data-tab]");
    const tabContentElems = tab.querySelectorAll("[data-tab-content]");

    // 最初のタブとコンテンツに active を付ける
    if (tabBtnElems.length > 0 && tabContentElems.length > 0) {
      tabBtnElems[0].classList.add("active");
      tabContentElems[0].classList.add("active");
      tabContentElems[0].style.display = "flex";
    }

    tabBtnElems.forEach((tabBtn) => {
      tabBtn.addEventListener("click", (e) => {
        e.preventDefault();
        const target = tabBtn.dataset.tab;

        tabBtnElems.forEach((btn) => btn.classList.remove("active"));
        tabContentElems.forEach((content, index) => {
          content.classList.remove("active");
          content.style.display = "none";

          if (`tab-${index}` === target) {
            content.classList.add("active");
            content.style.display = "flex";
          }
        });

        tabBtn.classList.add("active");
      });
    });
  });
}

// TOP よくある質問 さらに見る
document.addEventListener('DOMContentLoaded', function () {
  const btn = document.querySelector('.top-question .btn-link');
  const items = document.querySelectorAll('.top-question__items');

  btn.addEventListener('click', function () {
    items.forEach(function (item) {
      item.style.display = 'block'; // 表示
    });
    btn.style.display = 'none'; // ボタンを非表示に
  });
});

// TOP 商品詳細 もっと見る
document.addEventListener('DOMContentLoaded', function () {
  const fullEl = document.querySelector('.js-description-full');
  const shortEl = document.querySelector('.js-description-short');

  if (!fullEl || !shortEl) return;

  const fullHTML = fullEl.innerHTML;

  const maxLength = window.innerWidth <= 749 ? 65 : 210;

  let currentLength = 0;
  let shortHTML = '';
  let appendedReadMore = false;

  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = fullHTML;

  const selfClosingTags = ['br', 'img', 'hr', 'input', 'meta', 'link'];

  function traverse(node) {
    for (const child of node.childNodes) {
      if (currentLength >= maxLength) break;

      if (child.nodeType === Node.TEXT_NODE) {
        const text = child.textContent;
        const remaining = maxLength - currentLength;
        const slice = text.slice(0, remaining);
        currentLength += slice.length;

        if (currentLength >= maxLength && !appendedReadMore) {
          shortHTML += slice + '… <span class="read-more-inline">さらに見る</span>';
          appendedReadMore = true;
          break;
        } else {
          shortHTML += slice;
        }
      } else if (child.nodeType === Node.ELEMENT_NODE) {
        const tagName = child.nodeName.toLowerCase();
        const attrStr = [...child.attributes].map(attr => ` ${attr.name}="${attr.value}"`).join('');

        if (selfClosingTags.includes(tagName)) {
          shortHTML += `<${tagName}${attrStr}>`;
        } else {
          shortHTML += `<${tagName}${attrStr}>`;
          traverse(child);
          shortHTML += `</${tagName}>`;
        }

        if (currentLength >= maxLength) break;
      }
    }
  }

  traverse(tempDiv);

  shortEl.innerHTML = shortHTML;

  const moreLink = shortEl.querySelector('.read-more-inline');
  if (moreLink) {
    moreLink.addEventListener('click', function () {
      shortEl.style.display = 'none';
      fullEl.style.display = 'block';
    });
  } else {
    fullEl.style.display = 'none';
  }
});


// LINEクーポン
document.addEventListener("DOMContentLoaded", function () {
  const banner = document.getElementById("lineCouponBanner");
  const closeBtn = document.getElementById("closeBannerBtn");
  const mvSection = document.querySelector(".top-mv");

  closeBtn.addEventListener("click", function () {
    banner.classList.remove("is-show");
    banner.dataset.closed = "true";
  });

  window.addEventListener("scroll", function () {
    if (banner.dataset.closed === "true") return;

    const mvBottom = mvSection.getBoundingClientRect().bottom;

    if (mvBottom < 200) {
      banner.classList.add("is-show");
    } else {
      banner.classList.remove("is-show");
    }
  });
});